import React, { useState } from 'react';
import { Image, Spin } from 'antd';
// import placeholderImg from '../../assets/pictures/placeholder.png';
// import placeholderImgH from '../../assets/pictures/placeholderH.png';
// import placeholderImgV from '../../assets/pictures/placeholderV.png';
// import placeholderImg from '../../assets/errorImage.png';
// import placeholderImgH from '../../assets/errorImage.png';
import loading from '../../assets/loading.png';
import './ProgressiveImage.css';

const ProgressiveImage = ({ src, alt, preview, aspectRatio }) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    const handleLoadStart = () => {
        setLoaded(false);
    };

    const handleLoadEnd = () => {
        setLoaded(true);
    };

    const handleError = () => {
        setError(true);
    };

    // const getPlaceholder = () => {
    //     switch (className) {
    //         case 'project-image':
    //         case 'project-details-image':
    //         case 'home-project-image':
    //             return loading;
    //         case 'team-member-image':
    //         case 'profile-image':
    //             return loading;
    //         default:
    //             return loading;
    //     }
    // };

    const containerStyle = { aspectRatio, alignContent:'center', background:"linear-gradient(135deg, #059941, #2f3589)" };

    return (
        <div className={`progressive-image-container`} style={containerStyle}>
            {!loaded && (
                <div className="spinner-container">
                    <Spin size="large"/>
                </div>
            )}

            <Image
                src={error ? loading : src}
                alt={alt}
                onLoadStart={handleLoadStart}
                onLoad={handleLoadEnd}
                onError={handleError}
                className={`progressive-image ${loaded ? 'loaded' : ''}`}
                preview={preview}
            />
        </div>
    );
};

export default ProgressiveImage;
